import { all, put, race } from 'redux-saga/effects';

import { selectWhen } from 'store/helpers';
import * as InsuranceCalculationActions from 'store/insuranceCalculation';
import * as InsuranceCalculationConstants from 'store/insuranceCalculation/constants';
import * as InsuranceCalculationSelectors from 'store/insuranceCalculation/selectors';
import * as UserSelectors from 'store/user/selectors';

import * as InsuranceConstants from '../../constants';
import { CreateStage, makeDeferred } from '../../helpers';
import * as InsuranceSelectors from '../../selectors';

export const insuranceStageGetInsuranceOrder = new CreateStage({
  action: InsuranceConstants.ACTIONS.GET_INSURANCE_ORDER,
  handler: function* () {
    const [carInstanceId, customerId, dealerId] = yield all([
      selectWhen(InsuranceSelectors.interlayerSelectCarInstanceId),
      selectWhen(InsuranceSelectors.interlayerSelectCustomerId),
      selectWhen(UserSelectors.getDealerId),
    ]);

    const { promise, resolve } = makeDeferred();

    yield put(
      InsuranceCalculationActions.insuranceGetOrderInfo({
        callback: resolve,
        carInstanceId,
        customerId,
        dealerId,
      })
    );

    const [, error] = yield race([
      promise,
      selectWhen(
        InsuranceCalculationSelectors.selectNestedErrors(
          InsuranceCalculationConstants.ERRORS.NETWORK
        ),
        Boolean
      ),
    ]);

    if (error) {
      CreateStage.throwError({ message: error });
    }
  },
  name: InsuranceConstants.STAGES_FIELDS.GET_INSURANCE_ORDER,
}).watcher;
